import { render, staticRenderFns } from "./WgtConfig.vue?vue&type=template&id=2a306bbd&"
import script from "./WgtConfig.vue?vue&type=script&lang=js&"
export * from "./WgtConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports